import { render, staticRenderFns } from "./hairdetail.vue?vue&type=template&id=408ac47c&"
import script from "./hairdetail.vue?vue&type=script&lang=js&"
export * from "./hairdetail.vue?vue&type=script&lang=js&"
import style0 from "./hairdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports